import React  from 'react';
import ReactDOM from 'react-dom';
import {I18nextProvider} from "react-i18next";
import { Provider }  from 'react-redux';
import './index.css';
import App from './App';

import i18n from './i18n';
import './helpers/axios.interceptors';

import { store } from "./helpers/store";
import * as serviceWorker from './serviceWorker';

import {registerLocale} from "react-datepicker";
import pl from "date-fns/locale/pl";
import en from "date-fns/locale/en-GB";
import ReduxToastr from "react-redux-toastr";

registerLocale('pl', pl);
registerLocale('en', en);

ReactDOM.render(
  <Provider store={store}>
      <ReduxToastr
          timeOut={15000}
          newestOnTop={false}
          preventDuplicates
          position="bottom-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          closeOnToastrClick
      />
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
